export function countWords(input) {
    // Remove extra spaces and trim the input
    input = input.trim().replace(/\s+/g, ' ');

    // Split the string into an array of words
    var words = input.split(' ');
 
    // Return the number of words
    return words.length;
}